import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    setFiltroPublicacion,
    fetchPublicacionesEncabezado
} from '../../../actions/publicacionesActions';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { customStyleFilter, DropDownArrow } from '../../../template/CustomStyle';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import PropTypes from 'prop-types';

const fechaFiltro = filtroMedioMes();

class PublicacionesFilter extends React.Component {
    constructor(props) {
        super(props);
        const estadoGuardado = this.props.filtroPublicaciones.estado;
        const idPublicacionGuardada = (this.props.filtroPublicaciones.idPublicacion || "").toString().trim();
        let estado = this.props.filtroPublicaciones.estadoLabel || this.switchEstado(estadoGuardado);

        this.state = {
            skuSeller: this.props.filtroPublicaciones.skuSeller,
            marca: {
                label: this.props.filtroPublicaciones.marcaLabel,
                value: this.props.filtroPublicaciones.value
            },
            categoria: {
                label: this.props.filtroPublicaciones.categoriaLabel,
                value: this.props.filtroPublicaciones.categoria
            },
            seller: {
                label: this.props.filtroPublicaciones.idSellerLabel,
                value: this.props.filtroPublicaciones.idSeller
            },
            estado: {
                label: estado,
                value: this.props.filtroPublicaciones.estado
            },
            idTipoPublicacion: {
                label: this.props.filtroPublicaciones.idTipoPublicacionLabel,
                value: this.props.filtroPublicaciones.idTipoPublicacion
            },
            sinStock: {
                label: this.props.filtroPublicaciones.sinStockLabel,
                value: this.props.filtroPublicaciones.sinStock
            },
            fechaPubDesde: this.props.filtroPublicaciones.fechaPubDesde ?? fechaFiltro.desde,
            fechaPubHasta: this.props.filtroPublicaciones.fechaPubHasta ?? fechaFiltro.hasta,
            skuMarket: this.props.filtroPublicaciones.skuMarket,
            variaciones: [],
            tipoPublicacion: [],
            idPublicacion: this.props.filtroPublicaciones.idPublicacion,
            estadoBloqueadoPorRespuesta: (estadoGuardado || "").toString().toLowerCase() === "eliminado" && idPublicacionGuardada !== "",
        }
    }

    componentDidUpdate(prevProps) {
        const resultadosPrevios = this.getResultadosPublicaciones(prevProps.publicaciones);
        const resultadosActuales = this.getResultadosPublicaciones(this.props.publicaciones);

        if (resultadosPrevios === resultadosActuales) return;
        if (!resultadosActuales.length) return;

        const estadoResultado = Number(resultadosActuales[0]?.estado);
        const idPublicacionActual = (this.state.idPublicacion || "").toString().trim();

        if (estadoResultado === 5 && idPublicacionActual !== "") {
            if (this.state.estado?.value !== "eliminado" || !this.state.estadoBloqueadoPorRespuesta) {
                this.setState({
                    estado: { value: "eliminado", label: "ELIMINADO" },
                    estadoBloqueadoPorRespuesta: true
                });

                if (this.props.filtroPublicaciones?.estado !== "eliminado") {
                    this.props.setFiltroPublicacion({
                        ...this.props.filtroPublicaciones,
                        estado: "eliminado",
                        estadoLabel: "ELIMINADO",
                        idPublicacion: idPublicacionActual
                    });
                }
            }
        }
    }

    getResultadosPublicaciones = (publicaciones) => {
        if (Array.isArray(publicaciones)) return publicaciones;
        if (Array.isArray(publicaciones?.elementos)) return publicaciones.elementos;
        return [];
    }


    onSelectSearchInputCategorias = (descripcion) => {
        this.props.fetchCategorias(descripcion);
    };

    onSelectSearchInputMarcas = (descripcion) => {
        this.props.fetchMarcas(descripcion);
    };

    onSelectSearchInputSellers = (descripcion, action) => {
        // Solo buscar cuando el usuario escribe, no cuando selecciona
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({ 
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
    };

    onFilter = (event) => {
        event.preventDefault();

        const skuSellerValue = this.state.skuSeller || "";
        const skuMarketValue = this.state.skuMarket || "";
        const idPublicacionValue = this.state.idPublicacion || "";
        const isSearchBySku = skuSellerValue !== "" || skuMarketValue !== "";
        const isSearchById = idPublicacionValue !== "";

        // Si se busca por SKU o por ID de publicación, no enviar fechas
        const shouldNullDates = isSearchBySku || isSearchById;

        let filtroPublicacion = {
            estado: this.state.estado.value,
            estadoLabel: this.state.estado.label,
            marca: this.state.marca.value,
            marcaLabel: this.state.marca.label,
            categoria: this.state.categoria.value,
            categoriaLabel: this.state.categoria.label,
            idSeller: this.state.seller.value,
            idSellerLabel: this.state.seller.label,
            idTipoPubli: this.state.idTipoPublicacion.value,
            idTipoPublicacionLabel: this.state.idTipoPublicacion.label,
            skuSeller: this.state.skuSeller,
            skuMarket: this.state.skuMarket,

            fechaPubDesde: shouldNullDates ? null : this.state.fechaPubDesde,
            fechaPubHasta: shouldNullDates ? null : this.state.fechaPubHasta,

            sinStock: this.state.sinStock?.value,
            sinStockLabel: this.state.sinStock?.label,
            idPublicacion: this.state.idPublicacion,

        };

        if (!this.props.allowSearchBySeller) {
            filtroPublicacion.idSeller = this.props.idSeller;
        }


        this.props.setFiltroPublicacion(filtroPublicacion);

        const exportPayload = {
            idSeller: Number.isNaN(Number.parseInt(filtroPublicacion.idSeller)) ? null : Number.parseInt(filtroPublicacion.idSeller),
            fechaPubDesde: shouldNullDates ? null : filtroPublicacion.fechaPubDesde,
            fechaPubHasta: shouldNullDates ? null : filtroPublicacion.fechaPubHasta,
            categoria: Number.isNaN(Number.parseInt(filtroPublicacion.categoria)) ? null : Number.parseInt(filtroPublicacion.categoria),
            marca: Number.isNaN(Number.parseInt(filtroPublicacion.marca)) ? null : Number.parseInt(filtroPublicacion.marca),
            estado: filtroPublicacion.estado,
            skuSeller: filtroPublicacion.skuSeller,
            skuMarket: filtroPublicacion.skuMarket,
            sinStock: filtroPublicacion.sinStock === "" ? null : filtroPublicacion.sinStock,
            idPublicacion: filtroPublicacion.idPublicacion,
            idTipoPubli: filtroPublicacion.idTipoPubli,
        };


        if (typeof this.props.requestParaExportar === 'function') {
            this.props.requestParaExportar(exportPayload);
        } else {
            // eslint-disable-next-line no-console
            console.warn('requestParaExportar no está definido o no es función');
        }
    };

    onClearFilter = (event) => {
        event.preventDefault();
        this.props.setInitialPage();

        let params = {
            idSeller: this.props.allowSearchBySeller ? null : this.props.idSeller,
            fechaPubHasta: fechaFiltro.hasta,
            fechaPubDesde: fechaFiltro.desde
        };

        if (this.props.shouldFetchOnClear) {
            this.props.fetchPublicacionesEncabezado(params);
        }

        this.props.setFiltroPublicacion(params);
        localStorage.removeItem("pagina");

        this.setState({
            marca: { label: "", value: "" },
            categoria: { label: "", value: "" },
            estado: { label: "", value: "" },
            estadoBloqueadoPorRespuesta: false,
            seller: { label: "", value: "" },
            skuSeller: "",
            skuMarket: "",
            fechaPubDesde: fechaFiltro.desde,
            fechaPubHasta: fechaFiltro.hasta,
            idTipoPublicacion: { label: "", value: "" },
            sinStock: { label: "", value: "" },
            idPublicacion: ""
        });

        if (this.props.onClearCantidad) {
            this.props.onClearCantidad();
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;

        this.setState({ [name]: value }, () => {
            const trimmed = (value || "").toString().trim();

            if ((name === "skuSeller" || name === "skuMarket") && trimmed !== "") {
                this.setState({
                    idPublicacion: "",
                    marca: { label: "", value: "" },
                    categoria: { label: "", value: "" },
                    seller: { label: "", value: "" },
                    estado: { label: "", value: "" },
                    idTipoPublicacion: { label: "", value: "" },
                    sinStock: { label: "", value: "" },
                    fechaPubDesde: null,
                    fechaPubHasta: null
                });
                return;
            }

            if (name === "idPublicacion" && trimmed !== "") {
                this.setState({
                    skuSeller: "",
                    skuMarket: "",
                    marca: { label: "", value: "" },
                    categoria: { label: "", value: "" },
                    seller: { label: "", value: "" },
                    estado: { label: "", value: "" },
                    idTipoPublicacion: { label: "", value: "" },
                    sinStock: { label: "", value: "" },
                    fechaPubDesde: "",
                    fechaPubHasta: "",
                    estadoBloqueadoPorRespuesta: false
                });
                return;
            }

            if (name === "fechaPubDesde") {
                this.setState({ fechaPubDesde: value });
            }

            if (name === "fechaPublicacionHasta") {
                this.setState({ fechaPubHasta: value });
            }
        });
    };

    mapVariaciones = () => {
        let variaciones = [];
        if (this.props.variaciones) {
            this.props.variaciones.forEach(variacion =>
                variaciones.unshift({
                    label: this.switchEstado(variacion.descripcion),
                    value: variacion.descripcion
                })
            );
        }

        if (
            this.state.estado?.value &&
            !variaciones.some(item => item.value === this.state.estado.value)
        ) {
            variaciones.unshift({
                value: this.state.estado.value,
                label: this.state.estado.label
            });
        }

        this.setState({ variaciones: variaciones });
    }

    mapTipoPublicacion = () => {
        let tipoPublicacion = [];
        if (this.props.tipoPublicacion) {
            this.props.tipoPublicacion.forEach(item =>
                tipoPublicacion.unshift({
                    label: item.descripcion,
                    value: item.codigo
                })
            );
        }
        this.setState({ tipoPublicacion });
    };

    switchEstado = (estado) => {
        switch (estado) {
            case "activo":
                return "ACTIVO";
            case "pendiente_activacion":
                return "PENDIENTE";
            case "pausado":
                return "PAUSADO";
            case "en_revision":
                return "EN REVISIÓN";
            case "eliminado":
            case "Eliminado":
                return "ELIMINADO";
            default:
                return estado;
        }
    };

    mapSellers = () => {
        // SIEMPRE cargar sellers cuando se abre el dropdown
        // Esto limpia cualquier filtro previo del dashboard u otras vistas
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    render() {

        const { allowSearchBySeller, loadingExport } = this.props;

        // Construir lista de sellers sin agregar "Todos" aquí (se maneja en el estado local)
        let listaSeller = (this.props.sellers || []).map(item => ({
            label: item.label,
            value: item.value ? item.value.toString() : ""
        }));
        
        // Agregar opción "Todos" si no está ya en la lista
        if (listaSeller.length > 0 && listaSeller[0]?.value !== "") {
            listaSeller.unshift({ value: "", label: "Todos" });
        }

        const listaCategoria = (this.props.categorias || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        const listaMarca = (this.props.marcas || []).map(item => ({
            label: item.label,
            value: item.value.toString()
        }));

        const stockOpciones = [
            { value: undefined, label: "Todos" },
            { value: true, label: "Sin Stock" },
            { value: false, label: "Con Stock" }
        ];

        const classIsModerador = allowSearchBySeller ? "col-lg-2" : "col-lg-3";

        const skuSellerValue = this.state.skuSeller || "";
        const skuMarketValue = this.state.skuMarket || "";
        const idPublicacionValue = this.state.idPublicacion || "";

        const isSearchBySku = skuSellerValue !== "" || skuMarketValue !== "";
        const isSearchById = idPublicacionValue !== "";
        const isFiltering = isSearchBySku || isSearchById;
        const isEstadoDisabled = isFiltering || this.state.estadoBloqueadoPorRespuesta;

        return (
            <div className="card card-body filter-card">
                <form
                    className="row form-material"
                    onSubmit={this.onFilter}
                    onReset={this.onClearFilter}
                >
                    <div className={classIsModerador}>
                        <label htmlFor="idPublicacionPublicacionFilter" className="label-oscura">ID Publicación</label>
                        <input
                            id="idPublicacionPublicacionesFilter"
                            type="text"
                            name="idPublicacion"
                            onChange={this.handleChange}
                            value={this.state.idPublicacion}
                            className="form-control"
                            disabled={isSearchBySku}
                        />
                    </div>

                    {allowSearchBySeller &&
                        <div className={classIsModerador}>
                            <label htmlFor="sellerPublicacionesFilter" className="label-oscura">Seller</label>
                            <Select
                                id="sellerPublicacionesFilter"
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyleFilter}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }
                    <div className={classIsModerador}>
                        <label htmlFor="skuSellerPublicacionesFilter" className="label-oscura">Sku Seller</label>
                        <input
                            id="skuSellerPublicacionesFilter"
                            type="text"
                            name="skuSeller"
                            onChange={this.handleChange}
                            value={this.state.skuSeller}
                            className="form-control"
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="skuMarketPublicacionesFilter" className="label-oscura">Sku Market</label>
                        <input
                            id="skuMarketPublicacionesFilter"
                            type="text"
                            name="skuMarket"
                            onChange={this.handleChange}
                            value={this.state.skuMarket}
                            className="form-control"
                            disabled={isSearchById}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="marcaPublicacionesFilter" className="label-oscura">Marca</label>
                        <Select
                            id="marcaPublicacionesFilter"
                            name="marca"
                            value={this.state.marca}
                            options={listaMarca}
                            onInputChange={this.onSelectSearchInputMarcas}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="categoriaPublicacionesFilter" className="label-oscura">Categoria</label>
                        <Select
                            id="categoriaPublicacionesFilter"
                            name="categoria"
                            value={this.state.categoria}
                            options={listaCategoria}
                            onInputChange={this.onSelectSearchInputCategorias}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className={classIsModerador}>
                        <label htmlFor="estadoPublicacionesFilter" className="label-oscura">Estado</label>
                        <Select
                            id="estadoPublicacionesFilter"
                            name="estado"
                            options={this.state.variaciones}
                            onChange={this.selectSearchHandler}
                            value={this.state.estado}
                            onMenuOpen={this.mapVariaciones}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyleFilter}
                            isDisabled={isEstadoDisabled}
                        />
                    </div>

                    <button style={{ border: "none", background: "none" }} name="fechaPubDesde" className={classIsModerador} onMouseEnter={this.handleChange}>
                        <label htmlFor="fechaDesdePublicacionesFilter" className="label-oscura">Fecha desde</label>
                        <input
                            id="fechaDesdePublicacionesFilter"
                            type="date"
                            name="fechaPubDesde"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubDesde}
                            disabled={isFiltering}
                        />
                    </button>

                    <button style={{ border: "none", background: "none" }} className={classIsModerador} name="fechaPublicacionHasta" onMouseEnter={this.handleChange}>
                        <label htmlFor="fechaHastaPublicacionesFilter" className="label-oscura">Fecha hasta</label>
                        <input
                            type="date"
                            name="fechaPublicacionHasta"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.fechaPubHasta}
                            disabled={isFiltering}
                        />
                    </button>

                    {allowSearchBySeller &&
                        <div className="col-lg-2">
                            <label htmlFor="tipoPublicacionPublicacionesFilter" className="label-oscura">Tipo publicación</label>
                            <Select
                                id="tipoPublicacionPublicacionesFilter"
                                name="idTipoPublicacion"
                                options={this.state.tipoPublicacion}
                                onChange={this.selectSearchHandler}
                                value={this.state.idTipoPublicacion}
                                onMenuOpen={this.mapTipoPublicacion}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                placeholder=""
                                styles={customStyleFilter}
                                isDisabled={isFiltering}
                            />
                        </div>
                    }

                    <div className={classIsModerador}>
                        <label htmlFor="stockPublicacionesFilter" className="label-oscura">Stock</label>
                        <Select
                            id="stockPublicacionesFilter"
                            name="stock"
                            options={stockOpciones}
                            onChange={(e) => this.setState({ sinStock: e })}
                            value={this.state.sinStock}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            placeholder=""
                            styles={customStyleFilter}
                            isDisabled={isFiltering}
                        />
                    </div>

                    <div className="row p-10">
                        <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                            <button
                                className="btn d-inline btn-sm btn-grey m-r-10"
                                disabled={loadingExport}
                                type="submit"
                            >
                                Buscar
                            </button>
                            <button className="btn btn-sm btn-grey d-inline" type="reset">
                                Limpiar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
PublicacionesFilter.propTypes = {
    filtroPublicaciones: PropTypes.shape({
        estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        skuSeller: PropTypes.number,
        marcaLabel: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        categoriaLabel: PropTypes.string,
        categoria: PropTypes.shape({
            nombre: PropTypes.string,
        }),
        idSellerLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idTipoPublicacionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idTipoPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sinStockLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sinStock: PropTypes.bool,
        fechaPubDesde: PropTypes.string,
        fechaPubHasta: PropTypes.string,
        skuMarket: PropTypes.number,
        idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        estadoLabel: PropTypes.string,
        internacional: PropTypes.bool
    }),
    fetchCategorias: PropTypes.func,
    fetchMarcas: PropTypes.func,
    fetchSellersFilter: PropTypes.func,
    allowSearchBySeller: PropTypes.bool,
    idSeller: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setFiltroPublicacion: PropTypes.func,
    setInitialPage: PropTypes.func,
    shouldFetchOnClear: PropTypes.bool,
    fetchPublicacionesEncabezado: PropTypes.func,
    onClearCantidad: PropTypes.func,
    variaciones: PropTypes.array,
    tipoPublicacion: PropTypes.array,
    loadingExport: PropTypes.bool,
    sellers: PropTypes.array,
    categorias: PropTypes.array,
    marcas: PropTypes.array,
    requestParaExportar: PropTypes.func,
    publicaciones: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        publicaciones: PropTypes.array,
    })])
}

const mapStateToProps = state => ({
    publicaciones: state.publicaciones.publicaciones,
    loadingPublicaciones: state.publicaciones.loadingPublicaciones,
    marcas: state.publicaciones.marcas,
    categorias: state.publicaciones.categorias,
    variaciones: state.publicaciones.variacionesPublicacion,
    sellers: state.sellers.filteredSellers,
    idSeller: state.general.idSeller,
    tipoPublicacion: state.tiposPublicacion.tiposPublicaciones.elementos,
    filtroPublicaciones: state.publicaciones.filtroPublicaciones,
});

export default connect(mapStateToProps, {
    fetchMarcas,
    fetchCategorias,
    fetchPublicaciones,
    fetchSellersFilter,
    setFiltroPublicacion,
    fetchPublicacionesEncabezado,
    // getSellerDesplegable
})(PublicacionesFilter);
